import * as React from "react";

import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "testify-flex testify-h-9 testify-w-full testify-rounded-md testify-border testify-border-input testify-bg-transparent testify-px-3 testify-py-1 testify-text-sm testify-shadow-sm testify-transition-colors testify-file:border-0 testify-file:bg-transparent testify-file:text-sm testify-file:font-medium testify-file:text-foreground testify-placeholder:text-muted-foreground focus-visible:testify-outline-none focus-visible:testify-ring-1 focus-visible:testify-ring-ring disabled:testify-cursor-not-allowed disabled:testify-opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
